require('./hireCardECardView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const hireCardECardActions = require('actions/hireCardECard');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer')
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardECardStep1 = require('components/hire/cardECard/hireCardECardStep1/hireCardECardStep1');
const HireCardECardStep2 = require('components/hire/cardECard/hireCardECardStep2/hireCardECardStep2');
const HireCardECardStep3 = require('components/hire/cardECard/hireCardECardStep3/hireCardECardStep3');
const HireCardECardSuccess = require('components/hire/cardECard/hireCardECardSuccess/hireCardECardSuccess');
const HireCardECardError = require('components/hire/cardECard/hireCardECardError/hireCardECardError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { CallMeBack } = require('components/callMeBack/callMeBack');

// @constants
const {
    REDIRECT_URL,
    SECOND_STEP,
    WIZARD_FIRST_STEP
} = require('constants/index');
const cardImageIds = {
    ES: 'B.506.003.002',
    DE: 'B.506.016.001',
    NL: 'B.506.017.001',
    PT: 'B.506.018.001'
};
const { HIRE_CARD_E_CARD } = require('constants/operationCodesAccounts');
const { WEB_INACTIVE_ACCOUNT_ENABLED, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/hire/cardECard/analytics/hireCardECardAnalytics');

class HireCardECardView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getHireCardImages,
            getBlockedAccounts,
            immAccounts,
            match: { params: { redirect } },
            resetPrecontractualDocumentMail,
            validateStep
        } = this.props;
        resetPrecontractualDocumentMail();
        getHireCardImages([this.getCardImage()]);
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_E_CARD);

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetTermsAndCondsText,
        } = this.props;

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();
    }

    getProcessDetail() {
        const cardImage = this.getCardImage().split('.');
        return `${cardImage[1]}.${cardImage[2]}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    getCardImage() {
        const { immProfile } = this.props;
        const countryCode = immProfile.get('originCountry')
        return cardImageIds[countryCode] || cardImageIds['ES'];
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardECard } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardECard.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            downloadECard,
            immAccounts,
            immHireCardECard,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immProfile
        } = this.props;
        const selectedAccount = immHireCardECard.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardECardSuccess
                    downloadECard={downloadECard}
                    immAccount={immAccount}
                    immHireCardECard={immHireCardECard}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immProfile={immProfile}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardECard,
            immAccounts,
            immContracts,
            immFlagBasedFeatures,
            immHireCardECard,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireInformation,
            immShippingAddressList,
            immPdfData,
            immProfile,
            requestPDFMerge,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardECard,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardECard.get('steps');

        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.ECOMMERCE_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.ECOMMERCE_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.ECOMMERCE_CARD_STEP_3_VIEW]({ productName }),
        ];
        const loadingFlag = immHireCardECard.get('loadingFlag');
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHireCardECard.get('visibleStep') - 1]}
                        visibleStep={immHireCardECard.get('visibleStep')}
                        wizardClass="hire-card-ecard__wizard"
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            isLoading={loadingFlag}
                            cancelButton={true}
                            position="first"
                        >
                            <HireCardECardStep1
                                flagBasedFeatures={immFlagBasedFeatures}
                                gestorCrossEnabled={immFlagBasedFeatures.get('web-gc-enabled')}
                                hireCmsKey="ecard"
                                immHireInformation={immHireInformation}
                                requestPDFMerge={requestPDFMerge}
                                contracts={immContracts}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardECardStep2
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immHireCardECard={immHireCardECard}
                                immHireCardNameSelector={immHireCardNameSelector}
                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hireCardECard-hire'}
                            isLoading={immHireCardECard.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <HireCardECardStep3
                                immAccounts={immAccounts}
                                immHireCardECard={immHireCardECard}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immProfile={immProfile}
                                immPdfData={immPdfData}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immShippingAddressList={immShippingAddressList}
                                immProfile={immProfile}
                                selectedAccount={immSteps.getIn([SECOND_STEP, 'accountId'])}
                                type="prepaid"
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardECard, immFlagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hireCardECard-pageTitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardECard-breadcrumb")
            }
        ];

        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardECard.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;
        if (immHireCardECard.get('error')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardECardError
                        immHireCardECard={immHireCardECard}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardECardError
                        immHireCardECard={immHireCardECard}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardECard.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-ecard">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardECardView.propTypes = {
    downloadECard: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func,
    getHireCardImages: PropTypes.func.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardECard: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immContracts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardECard: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immShippingAddressList: PropTypes.object.isRequired,
};

module.exports.constructor = HireCardECardView;
module.exports.HireCardECardView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immContracts: state.globalVariables.getIn(['variables', 'parameters', 'contratos']),
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireCardECard: state.hireCardECard,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immPdfData: state.precontractualsMergePdfs,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
    }),
    {
        downloadECard: hireCardECardActions.downloadECard,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        handleAccountChange: hireCardECardActions.setAccount,
        handleAgreementCheckboxChange: hireCardECardActions.setAgreementCheckbox,
        hireCardECard: hireCardECardActions.hireCardECard,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        reset: hireCardECardActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setAllAccountsToInactive: hireCardECardActions.setAllAccountsToInactive,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardECardActions.setVisibleStep,
        setWillCancel: hireCardECardActions.setWillCancel,
        validateStep: hireCardECardActions.validateStep,
    }
)(withRouter(HireCardECardView));
